import { PresentationProduct } from "../../model";

export const BANNER_ROW_IDENTIFIER = "banner-row";
export const BANNER_TILE_IDENTIFIER = "banner-tile";

export interface ProductThemes {
  [key: string]: {
    title: string;
    slogan: string;
    name: string;
    id: string;
    custom_fields?: {
      Position: string;
      Callout: string;
    };
    static_content: {
      image_1: {
        type: "image" | "jpg";
        value?: string;
        link?: {
          target?: string;
          new_window: boolean;
        };
      };
    };
  };
}

export const addBannerToProductList = (
  productList: PresentationProduct[],
  bannerDetails: ProductThemes,
) => {
  for (const key in bannerDetails) {
    if (!bannerDetails.hasOwnProperty(key)) continue;

    const bannerOrTile = bannerDetails[key];
    const position = bannerOrTile?.custom_fields?.Position;

    if (position && !isNaN(parseInt(position, 10))) {
      const positionInt = parseInt(position, 10);
      const duplicatedObject = { ...productList[positionInt] };
      const isTile = (key || "")?.toUpperCase()?.indexOf("PLP_TILE") > -1;
      const isRow = (key || "")?.toUpperCase()?.indexOf("PLP_ROW") > -1;

      if (isRow || isTile) {
        duplicatedObject.id = isRow
          ? BANNER_ROW_IDENTIFIER
          : BANNER_TILE_IDENTIFIER;
        duplicatedObject.imageUrl =
          bannerOrTile?.static_content?.image_1?.value || "";
        duplicatedObject.url =
          bannerOrTile?.static_content?.image_1?.link?.target || "";
        duplicatedObject.fh_name = bannerOrTile?.name;
        duplicatedObject.fh_slogan = bannerOrTile?.slogan;
        productList.splice(positionInt - 1, 0, duplicatedObject);
      }
    }
  }
  return productList;
};
